<template>
  <div class="deviceDetailsList">
    <div class="photoBox">
      <el-image :src="list.img" style="width: 100%; height: 100%" fit="fill">
        <div slot="error" class="image-slot">
          <el-empty description=""></el-empty>
        </div>
      </el-image>
      <div
        class="state"
        :style="{
          background: list.active ? '#27df7c' : '#e7e7e7',
          color: list.active ? '#fff' : '#999',
        }"
      >
        {{ list.active ? "在 线" : "离 线" }}
      </div>
    </div>
    <ul class="detailsListWrap">
      <li>
        <p>名称:</p>
        <p>{{ list.name }}</p>
      </li>
      <li
        v-if="$route.path == '/energyuse' || $route.path == '/equipmentConsume'"
      >
        <p>运行状态:</p>
        <p
          :style="{
            color:
              list.state == '1' ? '#00c0a3' : list.state == '0' ? 'red' : '',
          }"
        >
          {{ list.state == "1" ? "正常" : list.state == "0" ? "异常" : "" }}
        </p>
      </li>
      <li>
        <p>设备类型:</p>
        <p>{{ list.type }}</p>
      </li>
      <li>
        <p>标签:</p>
        <p>{{ list.label }}</p>
      </li>
      <li>
        <p>表号:</p>
        <p>{{ list.num }}</p>
      </li>
      <li>
        <p>编码:</p>
        <p>{{ list.encode }}</p>
      </li>
      <li>
        <p>所属资产:</p>
        <p>{{ list.upperAssetName }}</p>
      </li>
      <li>
        <p>所属资产类型:</p>
        <p>{{ list.upperAssetType }}</p>
      </li>
      <li>
        <p>关联设备:</p>
        <div class="equipmentList">
          <el-button
            type="primary"
            plain
            size="mini"
            style="margin: 0 5px 5px 0; width: 100%; white-space: normal"
            v-for="(v, i) in list.relatedDevice"
            :key="i"
            :disabled="!v.label || $route.path == '/equipmentConsume'"
            @click="jumpEquipment(v)"
            >{{ v.name }}</el-button
          >
        </div>
      </li>
      <li>
        <p>安装地点:</p>
        <p>
          {{ list.location }}
        </p>
      </li>
      <li>
        <p>安装时间:</p>
        <p>{{ list.time ? list.time : list.createdTime }}</p>
      </li>
      <li>
        <p>备注:</p>
        <p>{{ list.remark ?? "" }}</p>
      </li>
    </ul>
    <el-dialog
      :visible.sync="showpup"
      width="69%"
      top="10vh"
      v-if="showpup"
      :before-close="handleClose"
    >
      <div class="pupComWrap">
        <RelationDialog :jumpItem="jumpItem" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
import RelationDialog from "@/components/shebeiguanli/equipment/RelationDialog.vue";
export default {
  components: {
    RelationDialog,
  },
  props: ["activeItem"],
  data() {
    return {
      list: {},
      showpup: false,
      jumpItem: {},
    };
  },
  watch: {
    activeItem: {
      handler(newvalue, oldvalue) {
        this.getDetailsList();
      },
      deep: true,
    },
  },
  methods: {
    async getDetailsList() {
      if (this.activeItem) {
        let res = await api.getSDetailsList(
          {},
          this.activeItem.deviceId
            ? this.activeItem.deviceId
            : this.activeItem.id.id
        );
        if (res && res.status == 200) {
          this.list = res.data;
          const time = res.data?.createdTime || res.data?.time;
          this.list.time = this._.isEmpty(time)
            ? ""
            : this.$moment(new Date(time)).format("yyyy-MM-DD");
          if (this.list.image) {
            let httpUrl = window.jujiParams.baseURL;
            this.list.img = `${httpUrl}/${this.list.image}?tenant_id=${
              JSON.parse(window.sessionStorage.getItem("userInfo")).tenantId
            }`;
          }
        }
      } else {
        this.list = {};
      }
    },
    handleClose() {
      this.$store.commit("SET_LOADING", false);
      this.showpup = false;
    },
    jumpEquipment(item) {
      this.showpup = true;
      this.jumpItem = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.deviceDetailsList {
  width: 93%;
  height: 94%;
  overflow: auto;

  ::v-deep .el-dialog__body {
    padding-bottom: 0;
  }

  .pupComWrap {
    height: 78vh;
  }

  .photoBox {
    width: 70%;
    height: 220px;
    margin: 0 auto;
    background: #f7f7f7;
    border: 1px solid #cccccc;
    border-radius: 20px;
    overflow: hidden;
    position: relative;

    .state {
      position: absolute;
      bottom: 0;
      left: 0;
      height: 40px;
      width: 100%;
      opacity: 0.8;
      background: #27df7c;
      color: #fff;
      @include setFlexCenter;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .detailsListWrap {
    width: 80%;
    margin: 20px auto;

    li {
      @include setFlexBetween;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin: 10px 0;

      p {
        width: 40%;
        color: #666;
        font-size: 14px;
      }

      p:last-child {
        width: 58%;
        color: #333;
      }

      .equipmentList {
        width: 58%;
      }
    }
  }
}
</style>
